import { findIndex } from "lodash";
import {default as ABSData} from "./absdata.js"
import {default as ABSDataBlank} from "./absdata-blank.js"

//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  lidOpen: false,
  cuvetteId: undefined,
  lidOpen: false,
  showInfoModal: false,
  showSettingsModal: false,
  poweredUp: false,
  absorbanceValue: 0,
  relativeAbsorbance: 0,
  wavelength: 350,
  solution: '',
};

export function SpectrophotometerReducer(
  state = { spectrophotometers: [] },
  action
) {
  let currentSpectrophotometer;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_SPECTROPHOTOMETER" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("spectrophotometers")
      ) {
        currentSpectrophotometer =
          state.protocolSection.scene.apparatus.spectrophotometers[
            findIndex(state.protocolSection.scene.apparatus.spectrophotometers, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_SPECTROPHOTOMETER":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("spectrophotometers")) {
        protocolSection.scene.apparatus.spectrophotometers = [
          ...protocolSection.scene.apparatus.spectrophotometers,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.spectrophotometers = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
      case 'SPECTROPHOTOMETER_TOGGLE_LID':
        currentSpectrophotometer.lidOpen = action.payload.isOpen
        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }
      case 'SPECTROPHOTOMETER_TOGGLE_SETTINGS_MODAL':
        currentSpectrophotometer.showSettingsModal = !currentSpectrophotometer.showSettingsModal;
        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }
      case 'SPECTROPHOTOMETER_TOGGLE_INFO_MODAL':
        currentSpectrophotometer.showInfoModal = !currentSpectrophotometer.showInfoModal;
        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }
      case 'SPECTROPHOTOMETER_DROP_ITEM':
        if(!action.payload.type == "Cuvette"){
          break;
        }

        currentSpectrophotometer.cuvetteId = action.payload.cuvetteId;
        currentSpectrophotometer.solution = action.payload.solution;

        let absorbanceValue = 0;

        if(currentSpectrophotometer.solution !== null && currentSpectrophotometer.solution.hasOwnProperty('H2O')){
          absorbanceValue = ABSDataBlank[findIndex(ABSDataBlank, (e)=> {
            return e.ph == currentSpectrophotometer.solution.H2O.pH && e.nm == currentSpectrophotometer.wavelength
          })].abs;
        }

        if(currentSpectrophotometer.solution !== null && currentSpectrophotometer.solution.hasOwnProperty('BTB')){
          absorbanceValue = ABSData[findIndex(ABSData, (e)=> {
            return e.ph == currentSpectrophotometer.solution.BTB.pH && e.nm == currentSpectrophotometer.wavelength
          })].abs + currentSpectrophotometer.relativeAbsorbance;
        }
        
        currentSpectrophotometer.absorbanceValue = randomBetween(absorbanceValue - 0.015, absorbanceValue + 0.015);

        var min = 0.11;
        var max = 1;
        var currentAbs = currentSpectrophotometer.absorbanceValue;
        var relativeAbs = currentSpectrophotometer.relativeAbsorbance;

        currentSpectrophotometer.absorbanceValue = (currentAbs - relativeAbs) < min ? min + relativeAbs : currentSpectrophotometer.absorbanceValue;
        currentSpectrophotometer.absorbanceValue = (currentAbs - relativeAbs) > max ? max + relativeAbs : currentSpectrophotometer.absorbanceValue;

        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }
      case 'SPECTROPHOTOMETER_REMOVE_CUVETTE':
        currentSpectrophotometer.cuvetteId = -1;
        currentSpectrophotometer.solution = '';
        currentSpectrophotometer.absorbanceValue = 0;
        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SPECTROPHOTOMETER_CLICK_POWER_BUTTON':
      currentSpectrophotometer.poweredUp = !currentSpectrophotometer.poweredUp;
      if(currentSpectrophotometer.poweredUp == false){
        currentSpectrophotometer.relativeAbsorbance = 0;
      }
      protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      case 'SPECTROPHOTOMETER_CLICK_ZERO_BUTTON':

      if (currentSpectrophotometer.cuvetteId) {
        currentSpectrophotometer.relativeAbsorbance = currentSpectrophotometer.absorbanceValue;
      }

      protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      case 'SPECTROPHOTOMETER_SET_WAVELENGTH':
        currentSpectrophotometer.wavelength = action.payload.wavelength;

        let absorbanceValue2 = 0;

        if(currentSpectrophotometer.solution.hasOwnProperty('H2O')){
          absorbanceValue2 = ABSDataBlank[findIndex(ABSDataBlank, (e)=> {
            return e.ph == 7 && e.nm == currentSpectrophotometer.wavelength
          })].abs;
        }

        if(currentSpectrophotometer.solution.hasOwnProperty('BTB')){
          absorbanceValue2 = ABSData[findIndex(ABSData, (e)=> {
            return e.ph == currentSpectrophotometer.solution.BTB.pH && e.nm == currentSpectrophotometer.wavelength
          })].abs + currentSpectrophotometer.relativeAbsorbance;
        }

        currentSpectrophotometer.absorbanceValue = randomBetween(absorbanceValue2 - 0.015, absorbanceValue2 + 0.015);

        var min = 0.11;
        var max = 1;
        var currentAbs = currentSpectrophotometer.absorbanceValue;
        var relativeAbs = currentSpectrophotometer.relativeAbsorbance;

        currentSpectrophotometer.absorbanceValue = (currentAbs - relativeAbs) < min ? min + relativeAbs : currentSpectrophotometer.absorbanceValue;
        currentSpectrophotometer.absorbanceValue = (currentAbs - relativeAbs) > max ? max + relativeAbs : currentSpectrophotometer.absorbanceValue;

        protocolSection.scene.apparatus.spectrophotometers[findIndex(state.spectrophotometers, { id: action.payload.id })] = currentSpectrophotometer

        return { ...state, ...{
          protocolSection: protocolSection
        } }
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('spectrophotometers')) {
        protocolSection.scene.apparatus.spectrophotometers =
          action.payload.lastState.scene.apparatus.spectrophotometers;
        
        protocolSection.scene.apparatus.spectrophotometers.forEach((spectrophotometer, index)=>{
          spectrophotometer.showInfoModal = false;
          spectrophotometer.showSettingsModal = false;
        })

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}

const randomBetween = (min, max) => {
  return Math.random() * (max - min) + min;
}
